<script setup lang="ts">
import type { TpgSelectEvent } from '@tpg/grammar-web';

export interface GrammarMenuProps {
  isOpen?: boolean;
  label?: string;
}

const props = withDefaults(defineProps<GrammarMenuProps>(), {
  isOpen: false,
  label: '',
});

const emit = defineEmits(['select']);
function onSelect(event: TpgSelectEvent) {
  emit('select', event);
}
</script>

<template>
  <tpg-menu v-bind="props" @tpg-select="onSelect">
    <slot />
  </tpg-menu>
</template>
